import { BuilderTheme } from "sharedUI/styles";
import { useTheme } from "styled-components";

export function useBuilderTheme() {
    return useTheme() as BuilderTheme;
}
